import { combine } from 'effector'
import { model as i18n } from '~/core/i18n'

export const $notificationTranslations = combine(i18n.$t, ({ t }) => ({
  title: t('unavailable_features_error'),
}))
